var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticStyle:{"padding":"10px"},domProps:{"innerHTML":_vm._s(_vm.$t('messages.Privacy'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }